import { LAYOUT_DRAWER_OUTSIDE_CLICK_EXCLUSION_SELECTORS } from '../layout.const'

import { isNodeInsideDrawer } from './isNodeInsideDrawer'

export const isNodeInsideDrawerOutsideClickExclusion = (
  target: EventTarget | null,
  drawerElement: HTMLElement | null
): boolean => {
  if (!(target instanceof Node)) {
    return false
  }

  if (isNodeInsideDrawer(target, drawerElement)) {
    return true
  }

  if (!(target instanceof Element)) {
    return false
  }

  return LAYOUT_DRAWER_OUTSIDE_CLICK_EXCLUSION_SELECTORS.some((selector) => target.closest(selector) !== null)
}
